module.exports = __webpack_public_path__ + "static/media/6.2a5538bb.jpg";